import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Alert, Link, Text } from '@amzn/storm-ui';
import {
  selectHeaderState,
  selectSpoofingInfo,
  SpoofingInfo,
} from '../../store/slice';
import { RootState } from 'src/app/store';

export const MobileSpoofingInfo: React.VFC<{
  spoofingInfo: SpoofingInfo;
  accountName?: string;
}> = ({ spoofingInfo, accountName }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Alert
      variant="info"
      hideIcon={true}
      withCloseButton={true}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <div>
        <Text size="xsmall">
          {spoofingInfo.label && (
            <Text weight="bold">{spoofingInfo.label}: </Text>
          )}
          {accountName}
        </Text>
      </div>
      <div>
        <Text size="xsmall">
          <Link
            href={spoofingInfo.quitButton.url}
            data-ccx-e2e-id="aac-quit-spoofing"
          >
            {spoofingInfo.quitButton.label}
          </Link>
        </Text>
      </div>
    </Alert>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    spoofingInfo: selectSpoofingInfo(state),
    accountName:
      selectHeaderState(state).currentAccountInfo?.currentAccountName,
  };
};

export default connect(mapStateToProps)(MobileSpoofingInfo);
